import { ERROR_STATUS } from 'site-modules/shared/constants/financing/financing';
import { DeclinedScreenError } from 'site-modules/financing/components/error-screen/components/declined-screen-error/declined-screen-error';
import { VerifyingScreenError } from 'site-modules/financing/components/error-screen/components/verifying-screen-error/verifying-screen-error';
import { PendingFurtherReviewScreenError } from 'site-modules/financing/components/error-screen/components/pending-further-review-screen-error/pending-further-review-screen-error';
import { SystemErrorScreen } from 'site-modules/financing/components/error-screen/components/system-error-screen/system-error-screen';
import { ExpiredScreenError } from 'site-modules/financing/components/error-screen/components/expired-screen-error/expired-screen-error';
import { PrequalNotFoundScreenError } from 'site-modules/financing/components/error-screen/components/prequal-not-found-screen-error/prequal-not-found-screen-error';
import { IneligibleVinScreenError } from 'site-modules/financing/components/error-screen/components/ineligible-vin-screen-error/ineligible-vin-screen-error';
import { VehicleNotFoundScreenError } from 'site-modules/financing/components/error-screen/components/vehicle-not-found-screen-error/vehicle-not-found-screen-error';

export const ERROR_DECLINED_DATA = {
  showFinancingVehicleInfoError: true,
  component: DeclinedScreenError,
};

export const ERROR_VERIFYING_DATA = {
  showFinancingVehicleInfoError: true,
  showCapOneLogo: true,
  showSrpLink: true,
  component: VerifyingScreenError,
};

export const ERROR_PENDING_FURTHER_REVIEW_DATA = {
  showFinancingVehicleInfoError: true,
  showCapOneLogo: true,
  showSrpLink: true,
  component: PendingFurtherReviewScreenError,
};

export const ERROR_SYSTEM_DATA = {
  showFinancingVehicleInfoError: true,
  component: SystemErrorScreen,
};

export const ERROR_EXPIRED_DATA = {
  showFinancingVehicleInfoError: true,
  component: ExpiredScreenError,
};

export const ERROR_PREQUAL_NOT_FOUND_DATA = {
  showFinancingVehicleInfoError: true,
  component: PrequalNotFoundScreenError,
};
export const ERROR_INELIGIBLE_DATA = {
  component: IneligibleVinScreenError,
};
export const ERROR_VEHICLE_NOT_FOUND_DATA = {
  component: VehicleNotFoundScreenError,
  hideVdpLink: true,
};

export const ERRORS_MAP = {
  [ERROR_STATUS.INELIGIBLE]: ERROR_INELIGIBLE_DATA,
  [ERROR_STATUS.DECLINED]: ERROR_DECLINED_DATA,
  [ERROR_STATUS.VERIFYING]: ERROR_VERIFYING_DATA,
  [ERROR_STATUS.PENDING_FURTHER_REVIEW]: ERROR_PENDING_FURTHER_REVIEW_DATA,
  [ERROR_STATUS.SYSTEM_ERROR]: ERROR_SYSTEM_DATA,
  [ERROR_STATUS.EXPIRED]: ERROR_EXPIRED_DATA,
  [ERROR_STATUS.PREQUAL_NOT_FOUND]: ERROR_PREQUAL_NOT_FOUND_DATA,
  [ERROR_STATUS.VEHICLE_NOT_FOUND]: ERROR_VEHICLE_NOT_FOUND_DATA,
};
